import React from 'react'
import { HightLight, Text } from '../gameRulesStyle'

export default function Vocabulary() {
  return (
    <>
      <HightLight fontSize='22px' background='blue' margin={'30px 0 0'}>
        {' '}
        Vocabulary
      </HightLight>
      <Text margin={'15px 0'}>
        <HightLight fontSize='18px' background='blue'>
          Roll
        </HightLight>{' '}
        - MEANS YOUR PLACED BET
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='red'>
          CYBERSCORE
        </HightLight>{' '}
        - MEANS RESULT NUMBER OF YOUR BET
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='green'>
          AUTOROLL
        </HightLight>{' '}
        - MEANS AUTOPLAY MODE
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='blue'>
          CONFIG
        </HightLight>{' '}
        - YOUR RECENT AUTOPLAY PREFERENCES
      </Text>
    </>
  )
}
